import axios from "axios"
import baseURL from "../configs/api"

export const post_ReservationAdditionalCharge = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}reservationAdditionalCharge?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_ReservationAdditionalCharge = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}reservationAdditionalCharge?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_ReservationAdditionalCharge = (primaryKey: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}reservationAdditionalCharge`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: { id: primaryKey, userId: userId }
    }).then(response => response.data);
}

export const getReservationAdditionalChargesReportByReservationId = (reservationId: number, tenantId: string) => {
    return getFetch(`reservationAdditionalCharge/GetReservationAdditionalChargeReportByReservationId/${reservationId}`, tenantId);
}

export const getReservationAdditionalChargesByReservationId = (reservationId: number, tenantId: string,) => {
    return getFetch(`reservationAdditionalCharge/GetReservationAdditionalCharges/${reservationId}`, tenantId);
}

export const getReservationAdditionalCharges = (tenantId: string,) => {
    return getFetch("reservationAdditionalCharge", tenantId);
}

export const getReservationAdditionalCharge = (primaryKey: string, tenantId: string,) => {
    return getFetch(`reservationAdditionalCharge/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}